import React, { useEffect, createElement } from 'react';
import AdvertorialGlp6TipsD from '../components/AdvertorialGlp6TipsD';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function Glp6TipsDPage() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with Pixel ID
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: '6 Essential Tips for GLP-1 Users',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18353">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18354">
        <Helmet data-id="element-18355">
          <title data-id="element-18356">6 Science-Backed Solutions for GLP-1 Side Effects</title>
          <meta property="og:title" content="6 Science-Backed Solutions for GLP-1 Side Effects" data-id="element-18357" />
          <meta property="og:description" content="After helping thousands of patients navigate GLP-1 medications, here are the critical insights that make all the difference between success and struggle." data-id="element-18358" />
          <meta property="og:type" content="article" data-id="element-18359" />
          <meta property="og:url" content={window.location.href} data-id="element-18360" />
          <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-18361" />
          <meta property="og:image:width" content="1200" data-id="element-18362" />
          <meta property="og:image:height" content="630" data-id="element-18363" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18364" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18365" />
          <meta name="twitter:title" content="6 Science-Backed Solutions for GLP-1 Side Effects" data-id="element-18366" />
          <meta name="twitter:description" content="After helping thousands of patients navigate GLP-1 medications, here are the critical insights that make all the difference between success and struggle." data-id="element-18367" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18368" />
          <meta name="twitter:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-18369" />
        </Helmet>
        <AdvertorialGlp6TipsD data-id="element-18370" />
      </div>
    </HelmetProvider>;
}